<template>
  <div class="car-unpetrified-com-goal">
    <!-- 如果有 customer:rollback 权限，显示 tab -->
    <el-tabs v-model="activeTab" v-permission="'customer:rollback'">
      <el-tab-pane label="目标客户" name="target">
        <car-unpetrified-com-goal-a />
      </el-tab-pane>
      <el-tab-pane name="secondary">
        <span slot="label">
          二次开发客户
          <el-tooltip 
            placement="right" 
            effect="light"
            content="针对前期终止开发的客户，管理员可操作筛选符合条件的客户，将其退回&quot;全部客户列表&quot;，以便客户经理再次领取与开发">
            <i class="el-icon-question" style="margin-left: 5px; color: #909399; cursor: pointer;"></i>
          </el-tooltip>
        </span>
        <car-unpetrified-com-goal-b />
      </el-tab-pane>
    </el-tabs>
    <!-- 如果没有 customer:rollback 权限，直接显示目标客户 -->
    <car-unpetrified-com-goal-a v-if="!$hasPermission('customer:rollback')" />
  </div>
</template>

<script>
import CarUnpetrifiedComGoalA from './carUnpetrifiedComGoalA/index.vue'
import CarUnpetrifiedComGoalB from './carUnpetrifiedComGoalB/index.vue'

export default {
  name: 'CarUnpetrifiedComGoal',
  components: {
    CarUnpetrifiedComGoalA,
    CarUnpetrifiedComGoalB
  },
  data() {
    return {
      // 当前激活的 tab，默认为目标客户
      activeTab: 'target'
    }
  }
}
</script>

<style scoped>
.car-unpetrified-com-goal {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.car-unpetrified-com-goal ::v-deep .el-tabs {
  background-color: #fff;
}

.car-unpetrified-com-goal ::v-deep .el-tabs__header {
  margin: 0;
  padding: 0 20px;
  background-color: #fff;
  border-bottom: none;
}

.car-unpetrified-com-goal ::v-deep .el-tabs__nav-wrap::after {
  display: none;
}

.car-unpetrified-com-goal ::v-deep .el-tabs__content {
  padding: 0;
  margin: 0;
}

.car-unpetrified-com-goal ::v-deep .el-tab-pane {
  padding: 0;
}
</style>
